/* RESPONSIBLE TEAM: team-app-security */
import Service, { inject as service } from '@ember/service';
import { post } from 'embercom/lib/ajax';
import type Session from 'embercom/services/session';

interface RevealResponse {
  value: string;
}

export default class PiiService extends Service {
  @service declare session: Session;

  get canRevealMaskedData(): boolean {
    if (!this.session.isTeammateLoaded) {
      return false;
    }
    return this.session.teammate.permissions?.canRevealMaskedData ?? false;
  }

  async revealField(userId: string, field: 'email' | 'phone'): Promise<string | null> {
    try {
      let response = (await post('/ember/pii/reveal', {
        app_id: this.session.workspace.id,
        user_id: userId,
        field,
      })) as RevealResponse;

      return response.value;
    } catch (error) {
      console.error('Failed to reveal PII field', error);
      return null;
    }
  }
}

declare module '@ember/service' {
  interface Registry {
    'pii-service': PiiService;
  }
}
